import React from "react";
import { Button } from "@shadcn-in-nx/ui/button";
import { RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";

function MonitoringHeader({ onRefresh, isLoading }) {
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-between">
            <h1 className="page-title">{t("monitoring.title")}</h1>
            <Button
                variant="outline"
                size="sm"
                onClick={onRefresh}
                disabled={isLoading}
                className="flex items-center gap-2"
            >
                <RotateCcw className={`h-4 w-4 ${isLoading ? "animate-spin" : ""}`} />
                {t("common.refresh")}
            </Button>
        </div>
    );
}

export default MonitoringHeader;
